import Navigation from "../data/Navigation";
import { INavigationLink } from "../interfaces/INavigation";


const FilterItems = (filter: (n: INavigationLink) => boolean) => {
    return Navigation
        .reduce((prev, curr) => ([...prev, ...curr.items]), [] as INavigationLink[])
        .reduce((prev, curr) => {
            if (curr.items !== null) {
                prev.push(...curr.items);
            } else {
                prev.push(curr);
            }
            
            return prev;
        }, [] as INavigationLink[])
        .filter(filter);
}


const NavigationHelper = {
    FilterItems
};

export default NavigationHelper;